import {
    IFacilityMatch,
    universalFacilitySearch,
} from 'es/app/business-logic/services/universal-search/FacilitySearch';
import { IUniversalSearchCriteria } from 'es/app/business-logic/services/universal-search/UniversalSearch';
import {
    UniversalSearchMatch,
    UniversalSearchResults,
} from 'es/app/components/layout/universal-search/UniversalSearchResults';
import SystemRouteMap from 'es/app/views/system/RouteMap';
import withSuspense from 'es/core/hocs/withSuspense';
import { useI18n } from 'es/core/hooks/useI18n';
import usePromiseTracker from 'es/core/hooks/usePromiseTracker';
import { useEffect, useState } from 'react';
import { usePromise } from 'react-use';

interface ISearchProvider {
    criteria: IUniversalSearchCriteria;
}

const FacilitySearchMatch = ({ facility }: { facility: IFacilityMatch }) => {
    const route = SystemRouteMap.facilities.edit(facility.id).root;

    return (
        <UniversalSearchMatch key={facility.id} heading={facility.name} match={facility} route={route}>
            {facility.site.toString()}
        </UniversalSearchMatch>
    );
};

const FacilitySearch = (props: ISearchProvider) => {
    const { l10n } = useI18n('app/components/layout', 'universalSearch');
    const { criteria } = props;

    const resolveIfMounted = usePromise();
    const { isBusy, trackPromise } = usePromiseTracker();

    const [searchResults, setSearchResults] = useState<IFacilityMatch[]>([]);

    useEffect(() => {
        setSearchResults([]);

        if (!(criteria.id || criteria.text)) {
            return;
        }

        const { abandon } = trackPromise(async () => {
            const facilities = await resolveIfMounted(universalFacilitySearch(criteria));
            setSearchResults(facilities);
        });

        return abandon;
    }, [criteria, criteria.id, criteria.text, resolveIfMounted, trackPromise]);

    if (!(isBusy || (searchResults && searchResults.length))) return null;

    return (
        <UniversalSearchResults provider={l10n('facilities.providerName')}>
            {isBusy && l10n('activity.searching')}

            {searchResults.map(facility => (
                <FacilitySearchMatch key={facility.id} facility={facility} />
            ))}
        </UniversalSearchResults>
    );
};

export default withSuspense(FacilitySearch);
